'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getFormId, getFormName, getSource, getSourceId, getTimestamp } from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
import { isFormSubmission } from 'conversations-message-history/crm-object-lifecycle-update/operators/isFormSubmission';
import { isSystemUpdate } from 'conversations-message-history/crm-object-lifecycle-update/operators/isSystemUpdate';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import Separator from '../atoms/Separator';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import FullSenderName from '../senders/components/FullSenderName';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import FormLink from './FormLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CrmTicketCreatedHeader = ({
  message,
  senders,
  userId,
  portalId
}) => {
  const senderId = getSourceId(message);
  const senderType = getSource(message);
  const asyncSender = findSender(senderId, senderType, senders);
  if (isSenderLoading(asyncSender)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 150
    });
  }
  const timestamp = /*#__PURE__*/_jsxs(Small, {
    children: [/*#__PURE__*/_jsx(Separator, {}), /*#__PURE__*/_jsx(FormattedDateTime, {
      value: getTimestamp(message),
      format: "LT",
      type: "userTz"
    })]
  });
  if (senderId === userId) {
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.createHeader.currentAgent"
      }), timestamp]
    });
  }
  if (isFormSubmission(message)) {
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.createHeader.formSubmission",
        options: {
          formName: /*#__PURE__*/_jsx(FormLink, {
            formName: getFormName(message),
            formId: getFormId(message),
            portalId: portalId
          })
        }
      }), timestamp]
    });
  }
  if (isSystemUpdate(message)) {
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.createHeader.system"
      }), timestamp]
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.createHeader.agent",
      options: {
        agent: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FullSenderName, {
            sender: getData(asyncSender)
          })
        })
      }
    }), timestamp]
  });
};
CrmTicketCreatedHeader.displayName = 'CrmTicketCreatedHeader';
CrmTicketCreatedHeader.propTypes = {
  message: RecordPropType('CrmObjectLifecycleUpdate').isRequired,
  portalId: PropTypes.number.isRequired,
  senders: SenderMap.isRequired,
  userId: PropTypes.number.isRequired
};
export default CrmTicketCreatedHeader;